<template>
  <div id="social" v-if="!hideSocial">
    <a
      @click="goTop"
      class="scroll-to-top"
      :class="{ 'active-arrow': active, absolute: isMobile }"
    ></a>

    <div
      class="social-fixed"
      :class="{ dark: this.$route.name === `Case Study`, absolute: isMobile }"
    >
      <a
        class="twitter"
        href="https://twitter.com/azterikcz"
        target="_blank"
        rel="noopener noreferrer"
        ><svg width="64pt" height="64pt" viewBox="0 0 64 64" version="1.1">
          <path
            d="M 56 17.117188 C 54.234375 17.898438 52.335938 18.429688 50.34375 18.664063 C 52.375 17.445313 53.9375 15.515625 54.671875 13.21875 C 52.773438 14.34375 50.664063 15.164063 48.421875 15.609375 C 46.625 13.695313 44.0625 12.492188 41.234375 12.492188 C 35.796875 12.492188 31.382813 16.90625 31.382813 22.34375 C 31.382813 23.117188 31.46875 23.867188 31.640625 24.585938 C 23.453125 24.179688 16.195313 20.257813 11.34375 14.296875 C 10.492188 15.75 10.007813 17.445313 10.007813 19.25 C 10.007813 22.664063 11.742188 25.679688 14.390625 27.445313 C 12.773438 27.390625 11.257813 26.953125 9.929688 26.210938 C 9.929688 26.257813 9.929688 26.296875 9.929688 26.335938 C 9.929688 31.109375 13.320313 35.09375 17.828125 35.992188 C 17 36.21875 16.132813 36.34375 15.234375 36.34375 C 14.601563 36.34375 13.976563 36.28125 13.382813 36.164063 C 14.632813 40.078125 18.273438 42.921875 22.578125 43.007813 C 19.210938 45.648438 14.960938 47.21875 10.351563 47.21875 C 9.554688 47.21875 8.773438 47.171875 8 47.078125 C 12.359375 49.875 17.53125 51.507813 23.09375 51.507813 C 41.210938 51.507813 51.117188 36.5 51.117188 23.484375 C 51.117188 23.0625 51.101563 22.632813 51.085938 22.210938 C 53.007813 20.820313 54.679688 19.085938 56 17.117188 Z "
          />
        </svg>
      </a>

      <a
        class="linkedin"
        href="https://www.linkedin.com/in/shox-adomokai"
        target="_blank"
        rel="noopener noreferrer"
        ><svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
          <path
            d="M 8 3.007813 C 4.53125 3.007813 2.007813 5.089844 2.007813 7.949219 C 2.007813 10.820313 4.589844 12.988281 8 12.988281 C 11.46875 12.988281 13.988281 10.871094 13.988281 7.890625 C 13.832031 5.019531 11.359375 3.007813 8 3.007813 Z M 3 15 C 2.449219 15 2 15.449219 2 16 L 2 45 C 2 45.550781 2.449219 46 3 46 L 13 46 C 13.550781 46 14 45.550781 14 45 L 14 16 C 14 15.449219 13.550781 15 13 15 Z M 18 15 C 17.449219 15 17 15.449219 17 16 L 17 45 C 17 45.550781 17.449219 46 18 46 L 27 46 C 27.550781 46 28 45.550781 28 45 L 28 29.5 C 28 27.128906 29.820313 25.199219 32.140625 25.019531 C 32.261719 25 32.378906 25 32.5 25 C 32.621094 25 32.738281 25 32.859375 25.019531 C 35.179688 25.199219 37 27.128906 37 29.5 L 37 45 C 37 45.550781 37.449219 46 38 46 L 47 46 C 47.550781 46 48 45.550781 48 45 L 48 28 C 48 21.53125 44.527344 15 36.789063 15 C 33.269531 15 30.609375 16.359375 29 17.488281 L 29 16 C 29 15.449219 28.550781 15 28 15 Z "
          />
        </svg>
      </a>

      <a
        class="behance"
        href="https://www.behance.net/ShoxAdomokai"
        target="_blank"
        rel="noopener noreferrer"
        ><svg width="64pt" height="64pt" viewBox="0 0 64 64" version="1.1">
          <path
            d="M 2 13.5 L 2 50.5 L 19.875 50.5 C 21.53125 50.5 32.9375 50.164063 32.9375 39.75 C 32.9375 33.242188 28.460938 31.03125 26.1875 30.375 C 27.859375 29.585938 31.1875 27.710938 31.1875 22.6875 C 31.1875 19.890625 30.789063 13.5 19.375 13.5 Z M 42.75 16.9375 L 42.75 20.3125 L 56.5625 20.3125 L 56.5625 16.9375 Z M 10.125 19.8125 L 17.75 19.8125 C 18.46875 19.8125 23.3125 19.429688 23.3125 24.0625 C 23.3125 28.023438 19.8125 28.4375 18.375 28.4375 L 10.125 28.4375 Z M 50 23.375 C 39.554688 23.375 37.375 32.445313 37.375 36.375 C 37.375 48.039063 46.9375 49.375 50 49.375 C 58.257813 49.375 60.601563 44.03125 61.5625 41.0625 L 55.5625 41.0625 C 55.328125 41.828125 53.578125 44.3125 50.25 44.3125 C 44.671875 44.3125 44.1875 39.953125 44.1875 38 L 61.9375 38 C 62.296875 31.25 59.34375 23.375 50 23.375 Z M 49.8125 28.4375 C 51.476563 28.4375 52.820313 28.921875 53.625 29.8125 C 54.429688 30.710938 55.023438 32.023438 55.1875 33.75 L 44.1875 33.75 C 44.21875 33.273438 44.328125 32.726563 44.5 32.125 C 44.671875 31.507813 44.9375 30.921875 45.375 30.375 C 45.8125 29.835938 46.421875 29.367188 47.125 29 C 47.84375 28.625 48.734375 28.4375 49.8125 28.4375 Z M 10.125 34 L 18.9375 34 C 20.6875 34 24.8125 34.273438 24.8125 39.3125 C 24.8125 44.195313 19.617188 44.1875 18.8125 44.1875 L 10.125 44.1875 Z "
          /></svg
      ></a>

      <a
        class="github"
        href="https://github.com/shoxadomokai"
        target="_blank"
        rel="noopener noreferrer"
        ><svg width="64pt" height="64pt" viewBox="0 0 64 64" version="1.1">
          <path
            d="M 32 8 C 18.742188 8 8 18.742188 8 32 C 8 42.601563 14.875 51.601563 24.414063 54.773438 C 25.617188 54.992188 26.054688 54.257813 26.054688 53.617188 C 26.054688 53.046875 26.03125 51.539063 26.023438 49.539063 C 19.34375 50.984375 17.9375 46.320313 17.9375 46.320313 C 16.84375 43.546875 15.273438 42.804688 15.273438 42.804688 C 13.09375 41.320313 15.4375 41.351563 15.4375 41.351563 C 17.84375 41.523438 19.109375 43.820313 19.109375 43.820313 C 21.25 47.492188 24.726563 46.429688 26.09375 45.820313 C 26.3125 44.265625 26.9375 43.210938 27.617188 42.609375 C 22.289063 42.007813 16.6875 39.945313 16.6875 30.75 C 16.6875 28.125 17.625 25.984375 19.15625 24.304688 C 18.914063 23.703125 18.085938 21.257813 19.390625 17.953125 C 19.390625 17.953125 21.40625 17.3125 25.992188 20.414063 C 27.90625 19.882813 29.960938 19.617188 32 19.609375 C 34.039063 19.617188 36.09375 19.882813 38.007813 20.414063 C 42.59375 17.3125 44.601563 17.953125 44.601563 17.953125 C 45.914063 21.257813 45.09375 23.703125 44.84375 24.304688 C 46.382813 25.984375 47.304688 28.125 47.304688 30.75 C 47.304688 39.96875 41.695313 41.992188 36.351563 42.59375 C 37.210938 43.328125 37.976563 44.796875 37.976563 47.03125 C 37.976563 50.242188 37.953125 52.828125 37.953125 53.617188 C 37.953125 54.257813 38.382813 55.007813 39.601563 54.773438 C 49.132813 51.59375 56 42.601563 56 32 C 56 18.742188 45.257813 8 32 8 Z "
          /></svg
      ></a>
    </div>
    <div
      class="copyr"
      :class="{ dark: this.$route.name === `Case Study`, absolute: isMobile }"
    >
      {{ year }} ©
      <a href="https://www.behance.net/ShoxAdomokai">Shox Adomokai</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      scrollingAnimation: null,
      isMobile: window.innerWidth < 750 ? true : false
    };
  },
  methods: {
    goTop() {
      document.querySelector("body").scrollIntoView({
        behavior: "smooth"
      });
    },
    checkSize() {
      if (window.innerWidth < 750) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    hideSocial() {
      return this.$route.name === "Case Study" && this.isMobile;
    }
  },
  mounted() {
    window.addEventListener(
      "scroll",
      (this.scrollingAnimation = () => {
        if (document.scrollingElement.scrollTop > window.innerHeight) {
          this.active = true;
        } else {
          this.active = false;
        }
      })
    );
    window.addEventListener("resize", this.checkSize);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollingAnimation);
    window.removeEventListener("resize", this.checkSize);
  }
};
</script>

<style lang="scss" scoped>
.social-fixed {
  position: fixed;
  top: auto;
  bottom: 40px;
  left: 10px;
  z-index: 94;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  transition: all 250ms linear;

  &.dark {
    svg {
      fill: $dark;
    }
  }
  img {
    width: 25px;
  }

  &.bottom-name {
    bottom: 140px;
  }

  a {
    position: relative;
    text-align: center;
    margin-top: 7px;
    margin-bottom: 7px;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    display: inline-block;
    transition: all 200ms linear;

    svg {
      height: 30px;
      fill: #fff;
      transition: 0.3s fill ease;
    }

    &.twitter:hover {
      svg {
        fill: #38a1f3;
      }
    }

    &.linkedin:hover {
      svg {
        fill: #0e76a8;
      }
    }

    &.behance:hover {
      svg {
        fill: #053eff;
      }
    }

    &.github:hover {
      svg {
        fill: #ad5c51;
      }
    }
  }
}

.copyr {
  position: fixed;
  bottom: 40px;
  right: 30px;
  z-index: 94;
  writing-mode: vertical-lr;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #fff;
  transform: rotate(180deg);

  &.dark {
    right: 50px;
    bottom: 20px;
    color: $dark;

    * {
      color: $dark;
    }
  }

  &.bottom-name {
    bottom: 140px;
  }

  a {
    color: #fff;
    transition: all 200ms linear;
    font-family: "taken by vultures demo", sans-serif;
    font-size: 18px;

    &:hover {
      opacity: 0.5;
    }
  }
}

.scroll-to-top {
  position: fixed;
  bottom: 210px;
  right: 36px;
  opacity: 0;
  visibility: hidden;
  width: 10px;
  height: 40px;
  z-index: 251;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 10px 40px;
  cursor: pointer;
  background-image: url(../assets/img/arrow-up.png);
  transform: translateY(-15px);
  transition: all 250ms linear;

  &.absolute {
    display: none;
  }
}

.absolute {
  position: absolute !important;
}
.scroll-to-top:hover {
  bottom: 212px;
  background-image: url(../assets/img/arrow-up-hover.png);
}
.scroll-to-top.active-arrow {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

@media (max-width: 1199px) {
  .social-fixed.bottom-name {
    bottom: 110px;
  }

  .copyr.bottom-name {
    bottom: 110px;
  }

  .social-fixed {
    bottom: 15px;
    left: 0px;
  }

  .copyr {
    bottom: 15px;
    right: 17px;
  }

  .scroll-to-top {
    right: 22px;
    bottom: 180px;
  }

  .scroll-to-top:hover {
    bottom: 182px;
  }
}
</style>
